import { CTabView } from "src/components/CTabView";
import { FinancialReportPage } from "./financial-report";
import { CustomerReportPage } from "./customer-report";
export function ReportPage() {
  return (
    <>
      <CTabView
        data={[
          {
            label: "Financial Report",
            component: <FinancialReportPage />,
          },
          {
            label: "Customer Report",
            component: <CustomerReportPage />,
          },
        ]}
      />
    </>
  );
}
